
import React from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface ScannerHeaderProps {
  onClose: () => void;
}

const ScannerHeader = ({ onClose }: ScannerHeaderProps) => {
  return (
    <div className="flex justify-between items-center p-4 bg-black/40 backdrop-blur-sm w-full">
      <h3 className="text-xl font-medium text-white">Quét QR Code</h3>
      <Button 
        variant="destructive" 
        size="icon" 
        onClick={onClose} 
        className="h-9 w-9 rounded-full hover:scale-110 transition-transform bg-white/10 hover:bg-white/20 border-0"
        aria-label="Đóng máy quét"
      >
        <X className="h-5 w-5 text-white" />
      </Button>
    </div>
  );
};

export default ScannerHeader;
